<template>
    <img
        src="~/assets/icon/icon-arrow-right.svg"
        alt=""
    />
</template>
<style scoped>
img {
    width: 25px;
    height:25px;
    transform: scaleX(-1);
}
</style>
